import { render, staticRenderFns } from "./BackAndForthFooter.vue?vue&type=template&id=54b700e8&scoped=true"
import script from "./BackAndForthFooter.vue?vue&type=script&lang=ts"
export * from "./BackAndForthFooter.vue?vue&type=script&lang=ts"
import style0 from "./BackAndForthFooter.vue?vue&type=style&index=0&id=54b700e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b700e8",
  null
  
)

export default component.exports